import { createSlice, PayloadAction } from "@reduxjs/toolkit";
interface TNext {
  id: string;
  createdAt: string;
  url: string;
}
type TWhiteboard = {
  room: string;
  ifConnected: boolean;
  numUsers: number;
  next: TNext | null;
  previous: TNext | null;
  roomState: string;
  changeUserAddress?: string;
  isScrollAbove: boolean;
  unreadMsg: any[];
  hotRoom: any[];
  unreadExist: boolean;
  unreadNext: string | null;
  adList: any[];
};

const initialState: TWhiteboard = {
  room: "",
  ifConnected: false,
  numUsers: 0,
  roomState: "",
  next: null,
  previous: null,
  isScrollAbove: false,
  unreadMsg: [],
  hotRoom: [],
  unreadExist: false,
  unreadNext: null,
  adList: [],
};

export const whiteboardSlice = createSlice({
  name: "whiteboard",
  initialState,
  reducers: {
    setRoom: (state, action: PayloadAction<string>) => {
      state.room = action.payload;
    },
    setIfConnected: (state, action: PayloadAction<boolean>) => {
      state.ifConnected = action.payload;
    },
    setRoomState: (state, action: PayloadAction<string>) => {
      state.roomState = action.payload;
    },
    setChangeUserAddress: (state, action: PayloadAction<string>) => {
      state.changeUserAddress = action.payload;
    },
    setNumUsers: (state, action: PayloadAction<number>) => {
      state.numUsers = action.payload;
    },
    setNext: (state, action: PayloadAction<TNext>) => {
      state.next = action.payload;
    },
    setPrevious: (state, action: PayloadAction<TNext>) => {
      state.previous = action.payload;
    },
    setIsScrollAbove: (state, action: PayloadAction<boolean>) => {
      state.isScrollAbove = action.payload;
    },
    setUnreadMsg: (state, action: PayloadAction<any[]>) => {
      state.unreadMsg = action.payload;
    },
    setUnreadExist: (state, action: PayloadAction<boolean>) => {
      state.unreadExist = action.payload;
    },
    setUnreadNext: (state, action: PayloadAction<string | null>) => {
      state.unreadNext = action.payload;
    },
    setHotRoom: (state, action: PayloadAction<any[]>) => {
      state.hotRoom = action.payload;
    },
    setAdList: (state, action: PayloadAction<any[]>) => {
      state.adList = action.payload;
    }
  },
});

// Action creators are generated for each case reducer function
export const {
  setRoom,
  setIfConnected,
  setRoomState,
  setChangeUserAddress,
  setNumUsers,
  setNext,
  setPrevious,
  setIsScrollAbove,
  setUnreadMsg,
  setHotRoom,
  setUnreadExist,
  setUnreadNext,
  setAdList,
} = whiteboardSlice.actions;

export default whiteboardSlice.reducer;
